module.exports = __webpack_public_path__ + "img/service-2.3576427a.png";